module.exports = __webpack_public_path__ + "img/newsImg.b3e8f219.png";